import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    account: Yup.string().required('Required').nullable(),
    lookupName: Yup.string().required('Required').nullable(),
  });
